import { render, staticRenderFns } from "./About_IPDetail_Item.vue?vue&type=template&id=253200f6&scoped=true"
import script from "./About_IPDetail_Item.vue?vue&type=script&lang=js"
export * from "./About_IPDetail_Item.vue?vue&type=script&lang=js"
import style0 from "./About_IPDetail_Item.vue?vue&type=style&index=0&id=253200f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253200f6",
  null
  
)

export default component.exports